// extracted by mini-css-extract-plugin
export default {"container":"ButtonAddTransactions_container__AijWB","wrapper":"ButtonAddTransactions_wrapper__3A3H9","icon":"ButtonAddTransactions_icon__SBoQ-"};